"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationReact = exports.Navigation = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var NavigationReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(NavigationReact, _React$Component);
  var _super = _createSuper(NavigationReact);
  function NavigationReact() {
    var _this;
    (0, _classCallCheck2.default)(this, NavigationReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "skipToPatientCenter", function () {
      var siteInfo = _this.props.siteInfo;
      var landingPageRedirectTo = siteInfo.landingPageRedirectTo,
        pgId = siteInfo.pgId,
        applicationStatus = siteInfo.applicationStatus,
        loanType = siteInfo.loanType,
        customFlow = siteInfo.customFlow,
        userInfo = siteInfo.userInfo,
        realm = siteInfo.realm;
      if (realm === 'LCYTS' || realm === 'LCK12') {
        // YTS
        var origin = window.location.origin;
        if (userInfo && userInfo.isPracticeUser) {
          window.location.href = "".concat(origin, "/dashboard?id=").concat(pgId, "&status=").concat(applicationStatus);
        } else {
          window.location.href = "".concat(origin, "/family-center");
        }
      } else {
        // LCPS
        if (userInfo && userInfo.isPracticeUser) {
          window.location.href = "".concat(landingPageRedirectTo, "dashboard?analyticsTrack=%2Fdashboard_done%26id=").concat(pgId, "%26status=").concat(applicationStatus, "%26loantype=").concat(loanType, "%26customFlow=").concat(customFlow);
        } else {
          window.location.href = "".concat(landingPageRedirectTo, "patient_center?analyticsTrack=%2Fpatient_center_done");
        }
      }
    });
    return _this;
  }
  (0, _createClass2.default)(NavigationReact, [{
    key: "submitACH",
    value: function submitACH() {
      this.props.ACHSubmitInProgress();
      this.props.submitACHInfo();
    }
  }, {
    key: "renderConfirmationPage",
    value: function renderConfirmationPage(flag) {
      this.props.makePageShowConfirmationPage(flag);
    }
  }, {
    key: "fillForm",
    value: function fillForm() {
      this.props.mockFillForm();
    }
  }, {
    key: "renderFillForm",
    value: function renderFillForm(siteInfo, form) {
      var _this2 = this;
      var siteEnv = siteInfo && siteInfo.env === 'prod' ? 'prod' : 'local';
      var cName = 'fillACHForm';
      if (siteEnv !== 'prod' && !form.showConfirmationPage) {
        return /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick() {
            return _this2.fillForm();
          },
          className: cName
        }, "Fill ACH Form");
      }
      return '';
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton() {
      var _this3 = this;
      var submitFormFlag = this.props.form.mandatoryFields.reduce(function (acc, curr, ind, arr) {
        if (!acc || !this.props.form.formData[curr] || this.props.form.formData[curr] === '') {
          return false;
        }
        return true;
      }.bind(this), true);
      var isErrorFields = this.props.form.errorFields.length > 0 ? false : true;
      var submitButtonClass = submitFormFlag && isErrorFields ? 'submitForm' : 'submitForm disabled';
      var isShowConfirmationPage = this.props.form.showConfirmationPage;
      var isAgreementChecked = this.props.form.formData.agreement;
      if (isShowConfirmationPage) {
        var backButton = /*#__PURE__*/_react.default.createElement("div", {
          onClick: function onClick() {
            return _this3.renderConfirmationPage(false);
          },
          tabIndex: "0",
          className: "go-back"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "align"
        }, " ", /*#__PURE__*/_react.default.createElement("div", null, " <"), " "));
        submitButtonClass = isAgreementChecked && this.props.form.navigationToNextPage === 'false' ? 'submitForm lastPage' : 'submitForm disabled';
        if (isAgreementChecked === 'checked' && this.props.form.navigationToNextPage === 'false') {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "submit-back-container"
          }, backButton, /*#__PURE__*/_react.default.createElement("button", {
            onClick: function onClick() {
              return _this3.submitACH();
            },
            tabIndex: "0",
            className: submitButtonClass
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "align"
          }, " ", /*#__PURE__*/_react.default.createElement("div", null, "Submit >"), " ")));
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "submit-back-container"
        }, backButton, /*#__PURE__*/_react.default.createElement("div", {
          className: submitButtonClass
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "align"
        }, " ", /*#__PURE__*/_react.default.createElement("div", null, "Submit >"), " ")));
      } else if (submitFormFlag) {
        var submitButton;
        submitButtonClass = isErrorFields ? 'submitForm firstPage' : 'submitForm disabled';
        if (submitFormFlag && isErrorFields) {
          submitButton = /*#__PURE__*/_react.default.createElement("button", {
            onClick: this.renderConfirmationPage.bind(this, true),
            className: submitButtonClass
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "align"
          }, /*#__PURE__*/_react.default.createElement("div", null, "Next >")));
        } else {
          submitButton = /*#__PURE__*/_react.default.createElement("div", {
            className: submitButtonClass
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "align"
          }, /*#__PURE__*/_react.default.createElement("div", null, "Next >")));
        }
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "submit-skip-wrapper"
        }, submitButton, /*#__PURE__*/_react.default.createElement("div", {
          tabIndex: "0",
          onClick: this.skipToPatientCenter,
          className: "skip"
        }, "Complete this step later"));
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "submit-skip-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: submitButtonClass
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "align"
      }, /*#__PURE__*/_react.default.createElement("div", null, "Next >"))), /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: "0",
        onClick: this.skipToPatientCenter,
        className: "skip"
      }, "Complete this step later"));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.form.showConfirmationPage !== this.props.form.showConfirmationPage) {
        window.scrollTo(500, 0);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        siteInfo = _this$props.siteInfo,
        form = _this$props.form;
      var containerClass = siteInfo && (siteInfo.realm === 'LCYTS' || siteInfo.realm === 'LCK12') ? 'submit-or-skip yts-parent' : siteInfo && siteInfo.realm === 'LCPS' ? 'submit-or-skip lcps-parent' : 'submit-or-skip';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClass
      }, this.renderSubmitButton(), this.renderFillForm(siteInfo, form));
    }
  }]);
  return NavigationReact;
}(_react.default.Component);
exports.NavigationReact = NavigationReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    form: state.form,
    siteInfo: state.siteInfo
  };
};
NavigationReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  form: _propTypes.default.shape({
    formData: _propTypes.default.object,
    navigationToNextPage: _propTypes.default.string,
    loanId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    showConfirmationPage: _propTypes.default.bool,
    errorFields: _propTypes.default.array,
    mandatoryFields: _propTypes.default.array
  }),
  ACHSubmitInProgress: _propTypes.default.func,
  submitACHInfo: _propTypes.default.func,
  mockFillForm: _propTypes.default.func,
  makePageShowConfirmationPage: _propTypes.default.func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Navigation = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavigationReact);
exports.Navigation = Navigation;
